import { createAction } from '@reduxjs/toolkit';
export var apiCallBegan = createAction('api/callBegan');
export var apiCallSuccess = createAction('api/callSuccess');
export var apiCallFailed = createAction('api/callFailed');
